export const descriptionElement = {
  fontSize: 12,
  marginBottom: "0.6rem"
};

export const titleElement = {
  marginBottom: "0.2rem"
};

export const textElement = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 700,
  color: "#757575",
  display: "inline"
};

export const inputLablElement = {
  padding: "6px 12px 6px 0px",
  borderRadius: "20px",
  backgroundColor: "#F2F2F2",
  marginRight: "12px",
  height: "34px",
  marginLeft: "0px"
};

export const inputCheckBox = {
  padding: "0 8px 0 12px",
  borderRadius: "20px",
  backgroundColor: "#F2F2F2",
  marginRight: "12px",
  height: "34px",
  marginLeft: "0px"
};

export const dropdownElement = {
  width: "auto",
  padding: "14px 12px",
  borderRadius: "4px",
  border: "1px",
  height: "40px"
};
